var map = {
	".": 373,
	"./": 373,
	"./App": 542,
	"./App.css": 2681,
	"./App.js": 542,
	"./assets/db/users": 1194,
	"./assets/db/users.js": 1194,
	"./assets/icons/bell.png": 2682,
	"./assets/icons/logo.png": 2683,
	"./assets/icons/profile.png": 2684,
	"./assets/img/black-logo.png": 796,
	"./assets/img/logo-sportmadness-large.png": 2685,
	"./assets/img/logo-sportmadness.png": 2686,
	"./assets/img/white-logo-lg.png": 430,
	"./assets/languages/i18n/en": 1195,
	"./assets/languages/i18n/en.js": 1195,
	"./assets/languages/i18n/es": 1196,
	"./assets/languages/i18n/es.js": 1196,
	"./assets/languages/i18n/fr": 1197,
	"./assets/languages/i18n/fr.js": 1197,
	"./assets/languages/icons/english.png": 2687,
	"./assets/languages/icons/france.png": 2688,
	"./assets/languages/icons/icon-france.png": 787,
	"./assets/languages/icons/icon-spain.png": 785,
	"./assets/languages/icons/icon-usa.png": 786,
	"./assets/languages/icons/spain.png": 2689,
	"./assets/languages/languages": 346,
	"./assets/languages/languages.js": 346,
	"./aws-exports": 1198,
	"./aws-exports.js": 1198,
	"./components/Content/Content": 558,
	"./components/Content/Content.js": 558,
	"./components/Home": 555,
	"./components/Home.js": 555,
	"./components/TopBar/TopBar": 556,
	"./components/TopBar/TopBar.js": 556,
	"./components/UI/Logo/Logo": 557,
	"./components/UI/Logo/Logo.css": 2690,
	"./components/UI/Logo/Logo.js": 557,
	"./config": 363,
	"./config.js": 363,
	"./containers/Academy/Courses/List": 339,
	"./containers/Academy/Courses/List/": 339,
	"./containers/Academy/Courses/List/index": 339,
	"./containers/Academy/Courses/List/index.js": 339,
	"./containers/Academy/Courses/Preview": 341,
	"./containers/Academy/Courses/Preview/": 341,
	"./containers/Academy/Courses/Preview/index": 341,
	"./containers/Academy/Courses/Preview/index.js": 341,
	"./containers/Academy/Courses/Single": 340,
	"./containers/Academy/Courses/Single/": 340,
	"./containers/Academy/Courses/Single/index": 340,
	"./containers/Academy/Courses/Single/index.js": 340,
	"./containers/Billing/List": 333,
	"./containers/Billing/List/": 333,
	"./containers/Billing/List/index": 333,
	"./containers/Billing/List/index.js": 333,
	"./containers/Billing/Office/List": 337,
	"./containers/Billing/Office/List/": 337,
	"./containers/Billing/Office/List/index": 337,
	"./containers/Billing/Office/List/index.js": 337,
	"./containers/Billing/Settings": 334,
	"./containers/Billing/Settings/": 334,
	"./containers/Billing/Settings/index": 334,
	"./containers/Billing/Settings/index.js": 334,
	"./containers/Billing/Single": 283,
	"./containers/Billing/Single/": 283,
	"./containers/Billing/Single/index": 283,
	"./containers/Billing/Single/index.js": 283,
	"./containers/Billing/Subscriptions/List": 335,
	"./containers/Billing/Subscriptions/List/": 335,
	"./containers/Billing/Subscriptions/List/index": 335,
	"./containers/Billing/Subscriptions/List/index.js": 335,
	"./containers/Billing/Subscriptions/Single": 336,
	"./containers/Billing/Subscriptions/Single/": 336,
	"./containers/Billing/Subscriptions/Single/index": 336,
	"./containers/Billing/Subscriptions/Single/index.js": 336,
	"./containers/Franchises/FranchisesOld": 1199,
	"./containers/Franchises/FranchisesOld.js": 1199,
	"./containers/Franchises/List": 282,
	"./containers/Franchises/List/": 282,
	"./containers/Franchises/List/index": 282,
	"./containers/Franchises/List/index.js": 282,
	"./containers/Franchises/Opportunity": 331,
	"./containers/Franchises/Opportunity/": 331,
	"./containers/Franchises/Opportunity/index": 331,
	"./containers/Franchises/Opportunity/index.js": 331,
	"./containers/Franchises/Project": 338,
	"./containers/Franchises/Project/": 338,
	"./containers/Franchises/Project/index": 338,
	"./containers/Franchises/Project/index.js": 338,
	"./containers/Franchises/Single": 332,
	"./containers/Franchises/Single/": 332,
	"./containers/Franchises/Single/index": 332,
	"./containers/Franchises/Single/index.js": 332,
	"./containers/Login/Login": 543,
	"./containers/Login/Login.js": 543,
	"./containers/ResetPassword": 329,
	"./containers/ResetPassword/": 329,
	"./containers/ResetPassword/index": 329,
	"./containers/ResetPassword/index.js": 329,
	"./containers/Template": 281,
	"./containers/Template/": 281,
	"./containers/Template/Template": 1200,
	"./containers/Template/Template.js": 1200,
	"./containers/Template/index": 281,
	"./containers/Template/index.js": 281,
	"./containers/Templates": 330,
	"./containers/Templates/": 330,
	"./containers/Templates/index": 330,
	"./containers/Templates/index.js": 330,
	"./containers/Users/Users": 559,
	"./containers/Users/Users.js": 559,
	"./core/MUITheme": 554,
	"./core/MUITheme.js": 554,
	"./core/axios": 79,
	"./core/axios.js": 79,
	"./hoc/Auxiliary/Auxiliary": 1201,
	"./hoc/Auxiliary/Auxiliary.js": 1201,
	"./index": 373,
	"./index.css": 1202,
	"./index.js": 373,
	"./providers/UserProvider": 63,
	"./providers/UserProvider.js": 63,
	"./serviceWorker": 1203,
	"./serviceWorker.js": 1203,
	"./services/central-academy/academy.services": 345,
	"./services/central-academy/academy.services.js": 345,
	"./services/central-billing/invoices.services": 187,
	"./services/central-billing/invoices.services.js": 187,
	"./services/central-billing/office.services": 564,
	"./services/central-billing/office.services.js": 564,
	"./services/central-billing/settings.services": 563,
	"./services/central-billing/settings.services.js": 563,
	"./services/central-billing/subscriptions.services": 344,
	"./services/central-billing/subscriptions.services.js": 344,
	"./services/central-templates/templates.services": 342,
	"./services/central-templates/templates.services.js": 342,
	"./services/franchise-billing/invoices.services": 561,
	"./services/franchise-billing/invoices.services.js": 561,
	"./services/franchise-crm/contacts.services": 560,
	"./services/franchise-crm/contacts.services.js": 560,
	"./services/franchise-crm/opportunities.services": 343,
	"./services/franchise-crm/opportunities.services.js": 343,
	"./services/franchise-projects/projects.services": 245,
	"./services/franchise-projects/projects.services.js": 245,
	"./services/franchises.services": 158,
	"./services/franchises.services.js": 158,
	"./services/templates.services": 565,
	"./services/templates.services.js": 565,
	"./services/users.services": 244,
	"./services/users.services.js": 244,
	"./utils/currency": 775,
	"./utils/currency.js": 775,
	"./utils/dashboard": 361,
	"./utils/dashboard.js": 361,
	"./utils/franchise": 562,
	"./utils/franchise.js": 562,
	"./utils/franchises": 360,
	"./utils/franchises.js": 360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2680;